import { useAppUpdate } from './useAppUpdate';
import { WhatsNewPrompt } from './WhatsNewPrompt';

/** Montowany raz w układzie aplikacji: pilnuje wersji, instaluje aktualizacje w bezpiecznym momencie i pokazuje „Co nowego”. */
export function AppUpdateWatcher() {
  useAppUpdate();
  return <WhatsNewPrompt />;
}
